import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IrrigationState } from './irrigation.entity';
import { controllerSelectors } from './controllers/controller.reducer';


export const irrigationFeatureSelector = createFeatureSelector<IrrigationState>('irrigationState');

export const getControllerState = createSelector(
    irrigationFeatureSelector,
    (state: IrrigationState) => state.controllers
);


export const getControllers = createSelector(
    getControllerState,
    state => state.controllerList
);

export const getCurrentController = createSelector(
    getControllerState,
    state => state.currentController
);

export const getCurrentStation = createSelector(
    getControllerState,
    state => state.currentStation
);
